import Nullstack from 'nullstack';
export default function IconBoxAlignBottom({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-box-align-bottom",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 14h16v5a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-5z"
  }), "   ", Nullstack.element("path", {
    d: "M4 9v.01"
  }), "   ", Nullstack.element("path", {
    d: "M4 4v.01"
  }), "   ", Nullstack.element("path", {
    d: "M9 4v.01"
  }), "   ", Nullstack.element("path", {
    d: "M15 4v.01"
  }), "   ", Nullstack.element("path", {
    d: "M20 4v.01"
  }), "   ", Nullstack.element("path", {
    d: "M20 9v.01"
  }), " ");
}